
export enum ClientAction
{
    ORDER_ASSIGN_USER = 'order_assign_user',
    ORDER_CANCEL_ASSIGN_USER = 'order_cancel_assign_user',
    ORDER_COMPLETE = 'order_complete',
    ORDER_ITEM_START = 'order_item_start',
    ORDER_ITEM_CANCEL_START = 'order_item_cancel_start',
    ORDER_ITEM_COMPLETE = 'order_item_complete',
    ORDER_ITEM_UPDATE_INFO = 'order_item_update_info',
    ORDER_IMAGE_ADD = 'order_image_add'
}